import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 300000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    // Store request start time
    config.metadata = { startTime: new Date() };

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    // const endTime = new Date();
    // const startTime = response.config.metadata?.startTime;
    // if (startTime) {
    //   const duration = endTime - startTime;
    //   console.log(`API call to ====${response.config.url} took ${duration} ms`);
    // }
    return response;
  },
  (error) => {
    // const endTime = new Date();
    // const startTime = error.config?.metadata?.startTime;
    // if (startTime) {
    //   const duration = endTime - startTime;
    //   console.warn(
    //     `API call to ${error.config.url} failed after ${duration} ms`
    //   );
    // }
    if (error.response?.data?.code === 403) {
      localStorage.removeItem("token");
      localStorage.removeItem("loginData");

      window.location.href = "/login";
    }

    console.error("API Error:", error.response?.data?.message || error.message);
    return Promise.reject(error);
  }
);

export default axiosInstance;
